export default __webpack_public_path__ + "static/media/services-section-bg.c5cc3bf0.png";